import { useToast } from "@agney/ir-toast";
import { IonAlert, IonCard, IonCheckbox } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { utilService } from "../../../../../../../services";
import { useTranslation } from "react-i18next";
import { availabListService } from "../../../AvailabilityList.service";
import { isPlatform } from "@ionic/react";
import "./AvailabilityListCard.scss";
import {
  availabListCardParams,
  RespAvailabListCardInterface,
} from "./Models/AvailabilityListCard.model";

interface availabListProps {
  // onCancel: () => void;
  isCardActive: () => void;
  isCardInactive: () => void;
  isEditActive: (cardData: any) => void;
  isEditInactive: () => void;
  availableListData: any;
  onDeleteCard?: any;
}

const AvailabilityListCard: React.FC<availabListProps> = (props) => {
  const Toast = useToast();
  const { t } = useTranslation("schedule");

  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [isIos, setisIos] = useState(false);

  const [isShowAlert, setIsShowAlert] = useState(false);
  const [listData, setAvailableListData] = useState<any>();

  useEffect(() => {
    if (!utilService.isEmpty(props.availableListData)) {
      setAvailableListData(props.availableListData);
    }
  }, [props.availableListData]);

  useEffect(() => {
    if (isPlatform("ios")) {
      setisIos(true);
    }
  }, []);

  const editClick = () => {
    props.isCardInactive();
    props.isEditActive(props.availableListData);
  };

  async function delAvailabilityList(params: availabListCardParams) {
    setLoaderStatus(true);
    const respDeletedAvailabCardResult: RespAvailabListCardInterface =
      await availabListService.removeAvailabilityList(params);
    if (respDeletedAvailabCardResult.isSuccess) {
      // const availabListCard = document.getElementById(
      //   `availabListCardId-${listData?.id}`
      // );
      // availabListCard?.style.setProperty("display", "none");
      props.onDeleteCard(listData?.id);
      Toast.success("Deleted successfully");
    } else {
      Toast.error(respDeletedAvailabCardResult.message);
      availabListService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const proceedDeleteCard = (key: number) => {
    const params = {
      delete_id: key,
      guid: utilService.getLoggedUserGuid(),
      page: 1,
      reg_code: utilService.getNetwork(),
    };
    delAvailabilityList(params);
  };

  return (
    <div>
      {/* <div className="back">
                <IonLabel className="img-wrap-back icon-back" onClick={props.onCancel}> Manage Availability Templates </IonLabel>
            </div> */}
      <div>
        <IonCard
          className="availablist-card-wrapper"
          id={`availabListCardId-${listData?.id}`}
        >
          <div className="header-icons">
            <div className="edit-icon" onClick={() => editClick()}>
              {listData?.editable === true ? (
                <span className="input-icon-edit icon-edit"></span>
              ) : (
                <span></span>
              )}
            </div>
            <div className="close-icon" onClick={() => setIsShowAlert(true)}>
              <span className="input-icon-delete icon-delete"></span>
            </div>
          </div>
          <IonAlert
            isOpen={isShowAlert}
            onDidDismiss={() => setIsShowAlert(false)}
            cssClass="sms-alert"
            header="Confirmation!"
            message="Are you sure you want to delete template?"
            buttons={[
              {
                text: "NO",
                role: "cancel",
                cssClass: "secondary",
              },
              {
                text: "OK",
                handler: () => {
                  proceedDeleteCard(listData?.id);
                },
              },
            ]}
          />
          <div className="list-card-data">
            <div className="date-data">
              <div className="start-date">
                <span className="start-date-header">{(t("startDate"))}</span>
                <span className="start-date-value">{listData?.startDate}</span>
              </div>
              <div className="end-date">
                <span className="end-date-header">{(t("endDate"))}</span>
                <span className="end-date-value">{listData?.endDate}</span>
              </div>
            </div>
            <div className="week-day-container">
              {listData && listData.data.length > 0 ? (
                listData.data.map((items: any) => {
                  return (
                    <div className="week-day-wrapper">
                      <span className="checkbox">
                        <IonCheckbox
                          color="dark"
                          item-left
                          checked={items.active}
                        ></IonCheckbox>
                      </span>
                      <span
                        className={`checkbox-label ${
                          isIos && "checkbox-label-ios"
                        }`}
                      >
                        {items?.name}
                      </span>
                    </div>
                  );
                })
              ) : (
                <div>{t("noResultsFound")}</div>
              )}
            </div>
            <div className="time-data">
              <div className="start-time">
                <span className="start-time-header">{t("fromTime")}</span>
                <span className="start-time-value">
                  {listData?.startDateTime}
                </span>
              </div>
              <div className="end-time">
                <span className="end-time-header">{t("toTime")}</span>
                <span className="end-time-value">{listData?.endDateTime}</span>
              </div>
            </div>
          </div>
        </IonCard>
      </div>
    </div>
  );
};
export default AvailabilityListCard;
